import { ChatMessage, messageKey } from '../protocol/types'

// A sent message carrying the fakeId of a local sending/failed message is the
// server acknowledgment of that message: the local copy is dropped regardless
// of the order the two arrive in.
export function mergeMessages(
  existing: readonly ChatMessage[],
  incoming: readonly ChatMessage[],
): ChatMessage[] {
  const all = [...existing, ...incoming]

  const acknowledgedFakeIds = new Set<string>()
  all.forEach(message => {
    if (message.state === 'sent' && message.fakeId) {
      acknowledgedFakeIds.add(message.fakeId)
    }
  })

  const byKey = new Map<string, ChatMessage>()
  all.forEach(message => {
    if (message.state !== 'sent' && acknowledgedFakeIds.has(message.fakeId)) {
      return
    }
    const key = messageKey(message)
    const present = byKey.get(key)
    if (!present || rank(message) >= rank(present)) {
      byKey.set(key, message)
    }
  })

  return [...byKey.values()].sort(
    (m1, m2) => m1.createdAt - m2.createdAt || compareKeys(m1, m2),
  )
}

function rank(message: ChatMessage): number {
  switch (message.state) {
    case 'sent':
      return 2
    case 'failed':
      return 1
    case 'sending':
      return 0
  }
}

function compareKeys(m1: ChatMessage, m2: ChatMessage): number {
  const k1 = messageKey(m1)
  const k2 = messageKey(m2)
  return k1 < k2 ? -1 : k1 > k2 ? 1 : 0
}
